import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { formatDate } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { LocalStorageService } from 'ngx-webstorage';
import Swal from 'sweetalert2';
import { VacBalanceModel, VacationDetModel, VacationTransModel } from 'src/app/models/VacationTransModel';
import { VacationTransService } from 'src/app/services/VacationTransService';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { DoctorssearchComponent } from '../doctorssearch/doctorssearch.component';
import { VactionRequestSearchComponent } from '../vaction-request-search/vaction-request-search.component';
import swal from 'sweetalert2';


@Component({
  selector: 'app-vaction-request',
  templateUrl: './vaction-request.component.html',
  styleUrls: ['./vaction-request.component.css']
})
export class VactionRequestComponent implements OnInit {

  vacnumber = 0 ;
  vacdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  vacempcode = '' ;
  empname = '';
  wk_DepartmentID = '';
  wk_DepartmentName = '';

  vackind = 'T' ;
  vactype = '' ;
  vacopenbalnce = 0 ;
  vactransactions = 0 ;
  vacbalance = 0 ;
  vacfrom = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  w_vacfrom :any;
  vacto   = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  w_vacto :any;
  vacdays = 0 ;
  vacnote = '' ;
  vacaltemp = '' ;
  vacaltempname = '';
  vacapproved = '' ;
  wk_Approved = false;
  vacperiod = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  wk_Transaction =0;
  wk_Swith = 'E';
  wk_From_Date :any;
  wk_To_Date :any;
  wornningmessage_Saved = 'Your work has been saved';
  wornningmessage_1 = 'Are you sure?';
  wornningmessage_2 = "You won't be able to revert this!";
  wornningmessage_3 = 'Yes, delete it!';
  wornningmessage_4 = 'Deleted!';
  wornningmessage_5 = 'Your file has been deleted.';
  wornningmessage_6 = 'cancel';


  @Output() submitClicked = new EventEmitter<any>();

  constructor(public storage: LocalStorageService,
              public vactransactionservice : VacationTransService,
              public vactransaction : VacationTransModel,
              public doctorservice : DoctorsService,
              private dialogref: MatDialog,
              public doctors : DoctorsModel,
              public vacationdet : VacationDetModel,
) { }

  ngOnInit(): void {

    this.GetNextSerial();
  }
  OpenDialog(){
    const dialogRef = this.dialogref.open(VactionRequestSearchComponent,
      {
        data: {
          dataKey: this.doctors

        },
        width: '50vw',

      });
    dialogRef.afterClosed().subscribe(result => {

    });
    const dialogSubmitSubscription =
    dialogRef.componentInstance.submitClicked.subscribe(result => {
      this.vacnumber = result.vacnumber;
      this. RertiveVacTrans();
      dialogSubmitSubscription.unsubscribe();
    });

  }
  RertiveVacTrans(){
    this.vactransactionservice.GetVacationTrans(this.vacnumber,'T', this.storage.retrieve('stgcompCode')).subscribe((data: VacationTransModel) => {
      this.vacdate = formatDate(data.vacdate, 'yyyy-MM-dd', 'en');
      this.vacempcode= data.vacempcode
      this.vackind= data.vackind
      this.vactype= data.vactype
      this.vacopenbalnce= data.vacopenbalnce
      this.vactransactions= data.vactransactions
      this.wk_Transaction = data.vactransactions
      this.vacbalance= data.vacbalance
      this.vacfrom= formatDate(data.vacfrom, 'yyyy-MM-dd', 'en');
      this.vacto= formatDate(data.vacto, 'yyyy-MM-dd', 'en');
      this.vacdays= data.vacdays
      this.vacnote= data.vacnote
      this.vacaltemp= data.vacaltemp
      this.vacapproved= data.vacapproved
      this.vacperiod= data.vacperiod
      if(this.vacapproved == 'Yes'){this.wk_Approved = true}
      if(this.vacapproved != 'Yes'){this.wk_Approved = false}
      this.doctorservice.getdoctors(this.vacempcode,this.storage.retrieve('stgcompCode')).subscribe(
        (data: DoctorsModel) => {

          //this.wk_DepartmentID = data.empdepartment
          this.empname= data.docName;

  }
  );
      this.RetriveAltEmployee();
  })
  }
  RetriveBalance(){
    this.vacbalance = 0;
    this.vacopenbalnce =0;
    this.vactransactions =0;
    this.vactransactionservice.GetVacationBalance(this.vacempcode,'O',this.vactype,this.vacperiod ,this.storage.retrieve('stgcompCode')).subscribe(
      (data: VacBalanceModel) => {
        this.vacopenbalnce = data.vactot
        this.vacbalance = this.vacopenbalnce - this.vactransactions;
       }
      );

      this.vactransactionservice.GetVacationBalance(this.vacempcode,'T',this.vactype,this.vacperiod ,this.storage.retrieve('stgcompCode')).subscribe(
        (data: VacBalanceModel) => {
          this.vactransactions = data.vactot
          this.wk_Transaction = this.vactransactions
          this.vacbalance = this.vacopenbalnce - this.vactransactions;

         }
        );

  }
  Calculate_No_OfDays(){

    // this.wk_From_Date = formatDate(this.vacfrom, 'dd', 'en');
    // this.wk_To_Date = formatDate(this.vacto, 'dd', 'en');

    this.wk_From_Date = new Date(this.vacfrom);
    this.wk_To_Date = new Date(this.vacto);
    this.vacdays = this.wk_To_Date.getTime() - this.wk_From_Date.getTime();

    this.vacdays =this.vacdays/(1000 * 60 * 60 * 24) +1;


    this.vactransactions =this.wk_Transaction + this.vacdays;
      this.vacbalance = this.vacopenbalnce - this.wk_Transaction;


  }

  SwithDialog1(){
    this.wk_Swith ='E';
    this.OpenDialogEmployee();
  }
  SwithDialog2(){
    this.wk_Swith ='A';
    this.OpenDialogEmployee();
  }
  OpenDialogEmployee(){

    const dialogRef = this.dialogref.open(DoctorssearchComponent,
      {
        data: {
          dataKey: this.doctors,
          searchtype : 'E',
          empdepartment: '',
          type:''
        },
        width: '50vw',

      });
    dialogRef.afterClosed().subscribe(result => {

    });
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        if (this.wk_Swith =='E'){
          this.vacempcode = result.docCode;
          this.RetriveEmployee();}
        if (this.wk_Swith =='A'){
          this.vacaltemp = result.docCode;
          this.RetriveAltEmployee();}

        dialogSubmitSubscription.unsubscribe();
      });
  }
  New_Data(){
    this.vacdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.vacempcode = '' ;
    this.empname = '';
    this.wk_DepartmentName='';
    this.vackind = 'T' ;
    this.vactype = '' ;
    this.vacopenbalnce = 0 ;
    this.vactransactions = 0 ;
    this.vacbalance = 0 ;
    this.vacfrom = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.vacto = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.vacdays = 0 ;
    this.vacnote = '' ;
    this.vacaltemp = '' ;
    this.vacaltempname = '';
    this.vacapproved = '' ;
    this.vacperiod = '' ;
    this.wk_Approved = false;
    this. GetNextSerial();
  }
  DeleteVacTrans(){
    this.vactransactionservice.DelVacationTrans(this.vacnumber,'T', this.storage.retrieve('stgcompCode')).subscribe(
      (data: VacationTransModel) => {

      }
    );
  }
  DeleteVacDet(){
    this.vactransactionservice.DelVacationDet(this.vacempcode,this.vacfrom,this.vacto,this.storage.retrieve('stgcompCode')).subscribe(
      (data: VacationDetModel) => {

      }
    );
  }

  mesgDelete(){
    if (this.storage.retrieve('stgLanguage') == 'E') {
      this.wornningmessage_1 = 'Are you sure?';
      this.wornningmessage_2 = "You won't be able to revert this!";
      this.wornningmessage_3 = 'Yes, delete it!';
      this.wornningmessage_4 = 'Deleted!';
      this.wornningmessage_5 = 'Your file has been deleted.';
      this.wornningmessage_6 = 'cancel';
    }
    if (this.storage.retrieve('stgLanguage') == 'A') {
      this.wornningmessage_1 = 'هل أنت متأكد ؟';
      this.wornningmessage_2 = 'عذرا لن تستطيع إيعادة هذا المستند!';
      this.wornningmessage_3 = 'نعم,أوافق على الإلغاء';
      this.wornningmessage_4 = 'تم الإلغاء !';
      this.wornningmessage_5 = ' هذا المستند تم إلغاءه بنجـــــاح !';
      this.wornningmessage_6 = 'تراجع';
    }
     swal({
          title:  this.wornningmessage_1,
          text: this.wornningmessage_2,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, keep it',
        }).then(
          () => {

            this.DeleteVacTrans(),
           this.New_Data(),
            swal('Deleted!', 'Your record has been deleted.', 'success');
          },
          function (dismiss) {
            if (dismiss === 'cancel') {
              swal('Cancelled', 'Your record is safe :)', 'error');
            }
          }
        );

  }
  Save_Data(){
    if (this.vacempcode == '' || this.vacempcode == null) {
      return;
    }
    if (this.vacdays < 0 ) {
      this.messageWorning();
      return;
    }
    debugger;
    this.vactransaction.vacnumber = this.vacnumber
    this.vactransaction.vacdate = this.vacdate
    this.vactransaction.vacempcode = this.vacempcode
    this.vactransaction.vackind = 'T'
    this.vactransaction.vactype = '1'
    this.vactransaction.vacopenbalnce = this.vacopenbalnce
    this.vactransaction.vactransactions = this.vactransactions
    this.vactransaction.vacbalance = this.vacbalance
    this.vactransaction.vacfrom = this.vacfrom
    this.vactransaction.vacto = this.vacto
    this.vactransaction.vacdays = this.vacdays
    this.vactransaction.vacnote = this.vacnote
    this.vactransaction.vacaltemp = this.vacaltemp
    this.vactransaction.vacperiod = this.vacperiod
    if (this.wk_Approved == true) {this.vactransaction.vacapproved= 'Yes'}
    if (this.wk_Approved == false) {this.vactransaction.vacapproved= 'No'}

    this.vactransaction.userid = this.storage.retrieve('stguserId');
    this.vactransaction.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.vactransaction.compcode = this.storage.retrieve('stgcompcode');

    this.vactransactionservice.AddVacationTrans(this.vactransaction).subscribe(data => {
    //  this.DeleteVacDet();

     // this.Save_VacationDet();

      this.mesgSave();
      this.New_Data();
    },
      error => { alert(error); }
    );
  }
  Save_VacationDet(){
    this.vactransactionservice.AddVacationDet(this.vacempcode,this.vacfrom,this.vacto ,this.vactype,'Leave',this.storage.retrieve('stgcompCode')).subscribe((data: VacationDetModel) => {

  })
  }

  RetriveEmployee(){
    this.doctorservice.getdoctors(this.vacempcode,this.storage.retrieve('stgcompCode')).subscribe(
      (data: DoctorsModel) => {

        this.empname= data.docName
        this.vacbalance =  0;
        this.vacopenbalnce =0;
        this.vactransactions =0;
        this.vacperiod='';
        this.vactype='';
}
);
  }
  RetriveAltEmployee(){
    this.doctorservice.getdoctors(this.vacaltemp,this.storage.retrieve('stgcompCode')).subscribe(
      (data: DoctorsModel) => {
        this.vacaltempname= data.docName
  }
  );
}

  GetNextSerial(){
    this.vactransactionservice.GetVacationTransSerial('T',this.storage.retrieve('stgcompCode')).subscribe((data: VacationTransModel) => {
        this.vacnumber = data.vacnumber;

    })
  }
  mesgSave() {
    if (this.storage.retrieve('stgLanguage') == 'E') {
      this.wornningmessage_Saved = 'Your work has been saved';

    }
    if (this.storage.retrieve('stgLanguage') == 'A') {
      this.wornningmessage_Saved = 'تم خفظ المستند بنجاح.';
    }
Swal({
  title: this.wornningmessage_Saved,

  type: 'success',
  showConfirmButton: false,

  timer: 1500
  });

  }
  messageWorning(){
    if (this.storage.retrieve('stgLanguage') == 'E') {
      this.wornningmessage_1 = 'Check Dates';
      this.wornningmessage_2 = "Please check the starting date and ending date";

    }
    if (this.storage.retrieve('stgLanguage') == 'A') {
      this.wornningmessage_1 = 'تاكد من التاريخ';
      this.wornningmessage_2 = 'يرجى التحقق من تاريخ البدء وتاريخ الانتهاء!';

    }
    Swal({
      title: this.wornningmessage_1,
      text: this.wornningmessage_2,
      type: 'warning',
      showConfirmButton: false,

      timer: 1500
      });

  }
}
